import { Skeleton } from '@/shared/components';

const MARKET_SKELETON_ROWS_QTY = 5;

const MarketRow = () => (
  <div className="flex items-center gap-[1.6rem]">
    <Skeleton variant="avatar" className="w-[3.2rem] bg-stroke" />
    <Skeleton variant="small" className="w-[9rem] bg-stroke" />
    <Skeleton variant="small" className="w-[8rem] ml-auto bg-stroke" />
    <Skeleton variant="small" className="w-[5.4rem] bg-stroke" />
    <Skeleton
      variant="medium"
      className="w-[6.4rem] rounded-[0.8rem] bg-stroke"
    />
  </div>
);

const MarketSectionSkeleton = () => {
  return (
    <div className="flex flex-col gap-[1.6rem]">
      <div className="flex items-center gap-[0.8rem]">
        <Skeleton
          variant="large"
          className="w-[10.4rem] rounded-full bg-stroke"
        />
        <Skeleton
          variant="large"
          className="w-[7.2rem] rounded-full bg-stroke"
        />
        <Skeleton
          variant="large"
          className="w-[8.8rem] rounded-full bg-stroke"
        />
        <Skeleton
          variant="large"
          className="w-[10rem] rounded-full bg-stroke"
        />
      </div>

      <div className="flex flex-col gap-[2.4rem] py-[2rem]">
        {Array.from({ length: MARKET_SKELETON_ROWS_QTY }).map((_, index) => (
          <MarketRow key={index} />
        ))}
      </div>

      <Skeleton
        variant="large"
        className="w-[14.4rem] h-[4.2rem] rounded-full bg-stroke"
      />
    </div>
  );
};

export { MarketSectionSkeleton };
